import React from "react";
import styled from "styled-components";
import Navigation from "./Navigation";
import { useSidebar } from "../contexts/SidebarContext";
import MobileWrapper from "./MobileWrapper/MobileWrapper";
import { NotificationProvider } from "../features/notifications/context/NotificationContext.jsx";

const LayoutContainer = styled.div`
  min-height: 100vh;
  background: #f9fafb;
  /* Account for fixed navigation + safe area on mobile */
  padding-top: calc(4rem + env(safe-area-inset-top, 0px));
  /* Allow overflow on mobile so dropdowns aren't clipped */
  overflow-x: visible;

  /* Prevent horizontal overflow during sidebar animation on desktop */
  @media (min-width: 768px) {
    padding-top: 4rem;
    overflow-x: clip;
  }
`;

const MainContent = styled.main`
  flex: 1;
  padding: 0; /* Padding handled by MobileWrapper */
  margin-left: 0;
  /* Important for flex/table layouts */
  min-width: 0;
  /* Default full width on mobile */
  width: 100%;
  /* Animate both offset and usable width */
  transition: margin-left 0.3s ease-in-out, width 0.3s ease-in-out;

  /* Account for sidebar width on tablet (768px+) and desktop */
  @media (min-width: 768px) {
    margin-left: ${(props) =>
      props.$isCollapsed ? "80px" : "280px"}; /* Account for sidebar width */
    width: ${(props) =>
      props.$isCollapsed ? "calc(100% - 80px)" : "calc(100% - 280px)"};
  }
`;

const Layout = ({ children }) => {
  const { isCollapsed } = useSidebar();

  return (
    <NotificationProvider>
      <LayoutContainer>
        <Navigation />
        <MainContent $isCollapsed={isCollapsed}>
          <MobileWrapper>{children}</MobileWrapper>
        </MainContent>
      </LayoutContainer>
    </NotificationProvider>
  );
};

export default Layout;
